// extracted by mini-css-extract-plugin
module.exports = {"product-recommand":"ProductRecomand_product-recommand__iifTz"};